"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jwt_decode_1 = __importDefault(require("jwt-decode"));
var useToken_1 = __importDefault(require("./useToken"));
function useUser() {
    var token = (0, useToken_1.default)();
    if (token === undefined)
        return undefined;
    var userInfo = (0, jwt_decode_1.default)(token);
    return userInfo;
}
exports.default = useUser;
//# sourceMappingURL=useUser.js.map